const $ = jQuery;
const { disableBodyScroll, enableBodyScroll } = require('body-scroll-lock');

class NavMenu {
	constructor() {
		this.header = document.querySelector('.main-header');
		this.hamburger = document.querySelector('.main-hamburger-menu');
		this.subItems = document.querySelectorAll('.menu-item-has-children');
		this.menu = document.querySelector('.main-header__right');
	}

	init() {
		this.hamburger.addEventListener( 'click', this.toggleMobileMenu.bind(this) );
		this.subItems.forEach( subItem => subItem.addEventListener( 'click', this.handleSubItemClick ) )
		this.setHeaderHeight();
	}

	loaded() {
		this.setHeaderHeight();
	}

	resized() {
		this.setHeaderHeight();
	}

	toggleMobileMenu() { 
		this.hamburger.classList.toggle('main-hamburger-menu--close');
		document.body.classList.toggle('mobile-menu-open');

		if ( document.body.classList.contains('mobile-menu-open') ) {
			disableBodyScroll( this.menu );
		} else {
			enableBodyScroll( this.menu );
		}
	}

	handleSubItemClick(e) {
		if ( 'A' === e.target.tagName ) return;

		e.target.classList.toggle('active');
		$( e.target ).find('.sub-menu').slideToggle(300);
	}

	setHeaderHeight() {
		document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
		document.documentElement.style.setProperty('--headerHeight', this.header.offsetHeight + "px");
	}
}

export default new NavMenu;